export const APP_VERSION = '2.0.18(1)'
